/**
 * Словарь брендов красок.
 *
 * На старте Phase 1 — только `RAL classic` (справочник 213 RAL-кодов с фото
 * фасадов в двух use case). Расширение на Tikkurila / Caparol — новый
 * CSV-adapter + добавление литерала в этот enum (ADR-0010 §1: один
 * paint-домен; разные бренды через расширение enum, не через
 * kind-discriminator).
 *
 * Используется:
 *   - в Zod-схеме `PaintBrandSchema` (`contracts/paint.ts`);
 *   - в UI-фильтрах Phase 3;
 *   - в адаптере `ral-classic.ts` (литерал `'RAL classic'`).
 */
export const PAINT_BRANDS = Object.freeze(['RAL classic'] as const);
export type PaintBrand = (typeof PAINT_BRANDS)[number];

export function getPaintBrands(): readonly PaintBrand[] {
  return PAINT_BRANDS;
}
